<!--

COMPONENTE PARA DIGITACAO DE QUANTIDADES NA GRADE DE UM PRODUTO

 -->

<script>

/*
params: {
  coditem: '',
  view: false,
  qt: 0,                     //QUANTIDADE TOTAL DIGITADA NA GRADE
  listItemGrade: []          //OBJETO PARA TRANSFERENCIA DOS ITENS DIGITADOS
}
*/

export default {
    props: {
      params: {}
    },

    data () {
      return {
        listItemGrade: [],        //LISTA COM CODIGOS DE ITEM/GRADE E QUANTIDADES PREENCHIDAS

        grade: {},
        colunasHead: [],          //PARA MONTAGEM DO CABECALHO DA TABELA DE GRADE

        quantidadeTotal: 0,
      }
    },

    computed: {
        item: function () {
          return this.$store.getters.getItem[0]
        },
    },

    watch: {
        grade: {
          handler () {
            //CALCULA A QUANTIDADE TOTAL DA GRADE QUANDO HOUVER ALTERACOES

            this.listItemGrade = []
            this.quantidadeTotal = 0

            for (var row = 0; row < this.grade.linhas.length; row++) {
              if (this.grade.linhas[row].coditemgrade) {
                this.quantidadeTotal = this.quantidadeTotal + parseFloat(this.grade.linhas[row].quantidade)
                this.listItemGrade.push({ qt: this.grade.linhas[row].quantidade, coditemgrade: this.grade.linhas[row].coditemgrade })
              }
              else
              if (this.grade.linhas[row].colunas) {   //EXISTE COLUNAS
                for (var col = 0; col < this.grade.linhas[row].colunas.length; col++) {
                  this.quantidadeTotal = this.quantidadeTotal + parseFloat(this.grade.linhas[row].colunas[col].quantidade)
                  this.listItemGrade.push({ qt: this.grade.linhas[row].colunas[col].quantidade, coditemgrade: this.grade.linhas[row].colunas[col].coditemgrade })
                }
              }
            }

            this.$emit('update', this.params.index, this.quantidadeTotal, this.listItemGrade)
          },
          deep: true,
        }
    },


    methods: {

      clickConfirma () {
      },

      async preparaGrade () {

        /*
        PREPARAÇÃO DA GRADE
        */

       this.listItemGrade = this.params.listItemGrade
       this.quantidadeTotal = this.params.qt

        await this.$store.dispatch('loadItem', { id: this.params.coditem } )
        if (!this.item) {
            return
        }

        this.grade = JSON.parse(this.item.grade)
        this.colunasHead = []

        let temp = null

        for (var row = 0; row < this.grade.linhas.length; row++) {
          if (this.grade.linhas[row].coditemgrade) {
            temp = this.getItemGrade(this.grade.linhas[row].coditemgrade)
            if (temp.lenght > 0) {
              this.grade.linhas[row].quantidade = temp[0].qt
            }
          } else
          if (this.grade.linhas[row].colunas) {   //EXISTE COLUNAS
            for (var col = 0; col < this.grade.linhas[row].colunas.length; col++) {
              if (this.grade.linhas[row].colunas[col].coditemgrade) {
                temp = this.getItemGrade(this.grade.linhas[row].colunas[col].coditemgrade)
                if (temp.length > 0) {
                  this.grade.linhas[row].colunas[col].quantidade = temp[0].qt
                }
              }
              if (row == 0) {
                this.colunasHead.push({ descricao: this.grade.linhas[row].colunas[col].descricao })
              }
            }
          }
        }

      },

      getItemGrade (coditemgrade) {
        return this.listItemGrade.filter((obj) => {
          return obj.coditemgrade == coditemgrade
        })
      },

      focus () {
        this.$nextTick(function () {
          if (this.$refs.quantidade)
            this.$refs.quantidade[0].focus()
        })
      }

    },

    created () {
      this.preparaGrade()
    }

}
</script>

<template>

  <div style="width: 80vh; overflow-x: auto">
    <div v-if="!params.view">
      <table class="table table-sm table-bordered table-striped" style="width: auto;">
        <thead>
          <tr>
            <th class="grade-cor sticky-col" style=""></th>
            <td class="text-center" style="min-width:70px;" v-for="(col, index) in colunasHead" :key="index">
              <div style="text-overflow:ellipsis; overflow:hidden;" class="" data-placement="top" data-original-title="">{{ col.descricao }}</div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in grade.linhas" :key="index">
            <th class="grade-cor sticky-col" style="max-width:200px; heigth: 40px;">
              <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" class="" data-placement="top" data-original-title="azul">{{ row.descricao }}</div>
            </th>
            <td class="text-center" style="max-width:70px;" v-for="(col, index) in row.colunas" :key="index">
              <input-number v-if="!params.view && col.ativo" ref="quantidade" class="form-control form-control-sm" v-model="col.quantidade"></input-number>
              <div v-if="params.view" class="lbl">{{col.quantidade}}</div>
            </td>
            <td class="text-center" style="max-width:70px;" v-if="row.coditemgrade">
              <input-number v-if="!params.view && row.ativo" ref="quantidade" class="form-control form-control-sm" v-model="row.quantidade"></input-number>
              <div v-if="params.view" class="lbl">{{row.quantidade}}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="w-100">
          <v-label label="Quantidade Total"></v-label>
          <span class="data-list"><strong>{{ quantidadeTotal | formatValue(0) }}</strong></span>
      </div>
    </div>

    <div v-if="params.view">
      <table class="table table-sm table-bordered table-striped" style="font-size: 11px;margin-left: 0; width: auto;">
        <thead>
          <tr>
            <th class="sticky-col" style=""></th>
            <td class="text-center" style="" v-for="(col, index) in colunasHead" :key="index">
              <div style="text-overflow:ellipsis; overflow:hidden;" class="">{{ col.descricao }}</div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in grade.linhas" :key="index">
            <th class="sticky-col" style="max-width:200px;">
              <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" class="">{{ row.descricao }}</div>
            </th>
            <td class="text-center" style="" v-for="(col, index) in row.colunas" :key="index">
              <div v-if="params.view" class="lbl">{{col.quantidade}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<style>

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
  left: 0px;
}

.grade-cor {
    height: 40px;
    padding: 10px;
    width: 200px;
    border-bottom: 1px solid #E0E0E0;
    -webkit-box-shadow: 3px 0 10px -4px #D3CDCD;
    -moz-box-shadow: 3px 0 10px -4px #D3CDCD;
    box-shadow: 3px 0 10px -4px #D3CDCD;
    background-color: #ffffff;
    left: 0;
}

</style>





// WEBPACK FOOTER //
// src/components/grade.vue